import React from "react";
import Routes from "./routes/Routes";
import AppContextWrapper from "context";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const link = new HttpLink({
  uri: process.env.REACT_APP_API_ + "/graphql",
  credentials: "include",
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("wrn_data_entry_token") || "";

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    possibleTypes: import("config/possibleTypes.json"),
  }),
});

const App = () => {
  return (
    <ApolloProvider client={client}>
      <AppContextWrapper>
        <Routes />
      </AppContextWrapper>
    </ApolloProvider>
  );
};

export default App;
